// Components
import { Box, Flex, Text } from 'yard-utilities/components'

// Helpers
import { formatNoun } from '@helpers/v25/formatNoun'

// Icons
import { LikeIcon, HeartIcon } from 'icons/v25/Icons'

// Styles
import styles from '../FacebookReviewCard.module.sass'

export interface FooterElementProps {
  comments: number
  likes?: number
}

const FooterElement = ({ comments, likes = 3 }: FooterElementProps) => {
  return (
    <Box padding={{ sm: [11, 16] }} className={styles.cardFooter}>
      <Flex alignItems="center" justifyContent="space-between">
        <Flex alignItems="center" columnGap={{ sm: 10 }}>
          <Flex>
            <LikeIcon />
            <HeartIcon />
          </Flex>

          <Text
            tagName="p"
            variant="body-3"
            textColor="black-60"
            fontFamily="arial"
          >
            Tú y {likes} persona{formatNoun(likes)} más
          </Text>
        </Flex>

        <Text
          tagName="p"
          variant="body-3"
          textColor="black-60"
          fontFamily="arial"
        >
          {comments} comentario{formatNoun(comments)}
        </Text>
      </Flex>
    </Box>
  )
}

export default FooterElement
